<template>
  <div class="login-wrap">
    <div class="login-navBar">
      <div
        :class="curIndex == index ? 'navBar-item active' : 'navBar-item'"
        v-for="(item, index) in navBar"
        :key="index"
        @click="navClick(index)"
      >
        {{ item.title }}
      </div>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="passRuleForm"
      class="login-form"
      label-width="0"
      @keyup.enter.native="submit"
      autocomplete="off"
    >
      <el-form-item label="" :prop="curInputProp">
        <el-input
          type="text"
          v-model="ruleForm[curInputProp]"
          auto-complete="off"
          class="login-input pass-input"
          :placeholder="`请输入${
            curInputProp === 'mobile' ? '手机号' : '邮箱地址'
          }`"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="password">
        <el-input
          type="password"
          placeholder="请输入密码"
          class="login-input pass-input"
          v-model="ruleForm.password"
          autocomplete="new-password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-tem class="submit-item">
        <el-button
          class="submit-btn"
          type="primary"
          @click="submit"
          :disabled="loginStatus"
          :loading="loginStatus"
        >
          登录
        </el-button>
      </el-form-tem>
    </el-form>
  </div>
</template>

<script>
import tokenFunc from '@/config/static/token'
export default {
  props: {
    isDialog: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    var validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        let reg = /^1[0-9]{10}/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        }
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入邮箱"));
      } else {
        let reg1 = /^([A-Za-z0-9]*[-_\.]?[A-Za-z0-9]+)*[A-Za-z0-9\._-]@[a-zA-Z\d]+\.[a-zA-Z]{1,5}$/;
        // let reg1 = /^([a-zA-Z\d])(\w|\-|\.)+@[a-zA-Z\d]+\.[a-zA-Z]{1,5}$/
        if (!reg1.test(value)) {
          callback(new Error("请输入正确的邮箱"));
        }
        callback();
      }
    };
    return {
      ruleForm: {
        mobile: "",
        email: "",
        password: "",
      },
      loginStatus: false, // 点击按钮请求是， 需禁用
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: validateEmail, trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      navBar: [
        {
          title: "手机号",
          prop: "mobile",
        },
        {
          title: "邮箱",
          prop: "email",
        },
      ],
      curIndex: 0,
      curInputProp: "mobile",
    };
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  methods: {
    navClick(ind) {
      this.curIndex = ind;
      this.curInputProp = this.navBar[ind].prop;
      this.$refs["passRuleForm"].resetFields();
    },
    submit() {
      var _this = this;
      this.loginStatus = true;
      this.$refs["passRuleForm"].validate((valid) => {
        if (valid) {
          let { password } = this.ruleForm;
          let loginParams = {
            register_type: 1,
            password,
          };
          loginParams[this.curInputProp] = this.ruleForm[this.curInputProp];
          let operation = "";
          if (this.curInputProp == "mobile") {
            operation = "password_login";
          } else if (this.curInputProp == "email") {
            operation = "email_password_login";
          }
          loginSdk
            .requestAction(operation, loginParams)
            .then((res) => {
              this.loginStatus = false;
              if (res.code == 0) {
                this.loginStatus = false;
                _this.$nextTick(() => {
                  _this.setLoginData(res.data);
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.loginStatus = false;
              this.$message.error(err);
            });
        } else {
          this.loginStatus = false;
        }
      });
    },
    async setLoginData(data) {
      this.$message.success("登录成功");
      tokenFunc.setToken(JSON.stringify(data.token))
      var res = await this.$store.dispatch("loginInfo");
      if (this.isDialog) {
        window.parent.postMessage({ type: "isLogin", val: data.token }, "*");
        return;
      }
      if (res) {
        this.$router.push({ name: "Team", query: this.$route.query });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form {
  padding: 0 50px;
  .el-form-item {
    margin-bottom: 24px;
  }
}
.login-navBar {
  width: calc(100% - 100px);
  height: 30px;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e7ec;
  margin: 0 auto 16px;
  .navBar-item {
    color: #3b3946;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    margin-right: 32px;
    cursor: pointer;
    user-select: none;
    font-weight: 500;
  }
  .active {
    color: #5a2df5;
    position: relative;
    &::after {
      content: "";
      width: 100%;
      height: 2px;
      display: block;
      position: absolute;
      left: 0;
      bottom: -10px;
      background-color: #5a2df5;
    }
  }
}
</style>
>
